/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/no-named-as-default */
/**
 *
 * App
 *
 * This component is the skeleton around the actual pages, and should only
 * contain code that should be seen on all pages. (e.g. navigation bar)
 */
import React from 'react';
import { Helmet } from 'react-helmet';
import styled from 'styled-components';
import { Switch, Route, Redirect } from 'react-router-dom';
import { ToastsContainer, ToastsStore, ToastsContainerPosition } from 'react-toasts';
import Login from '../ViewController/Login/Loadable';
import PageNotFound from '../ViewController/PageNotFound/Loadable';
import ThankYou from '../ViewController/ThankYou/Loadable';
import Profile from '../ViewController/Profile/Loadable';
import AbsenceForm from '../ViewController/AbsenceForm/Loadable';
import AbsenceDetail from '../ViewController/AbsenceForm/AbsenceDetail';
import EarlyLeaveForm from '../ViewController/EarlyLeaveForm/Loadable';
import ClearAbsence from '../ViewController/ClearAbsence';
import '../assets/global.css';
import '../assets/details-shim.min.css';
import ParentContact from '../ViewController/ParentContactDetails';

const AppWrapper = styled.div`
  max-width: 1000px;
  margin: 0 auto; 
  display: flex;
  min-height: 100%;
  padding: 0 16px;
  flex-direction: column;
`;

const PrivateRoute = ({ children, ...rest }) => {
  const userDetails = JSON.parse(sessionStorage.getItem('login_details'));
  if (userDetails) {
    return (
      <Route
        {...rest}
        render={() => (children)}
      />
    );
  }
  return (
    <Route
      {...rest}
      render={({ location }) => ((userDetails) ? (children) : (
        <Redirect
          to={{
            pathname: '/login',
            state: { from: location },
          }}
          exact
        />
      ))}
    />
  );
};

const App = () => (
  <AppWrapper>
    <Helmet
      titleTemplate="El Camino Real Charter High School - Online Forms"
      defaultTitle="El Camino Real Charter High School - Online Forms"
    >
      <meta
        name="description"
        content="El Camino Real Charter High School - Online Forms"
      />
    </Helmet>
    <ToastsContainer
      store={ToastsStore}
      position={ToastsContainerPosition.TOP_RIGHT}
    />
    <Switch>
      <Route path="/login" component={Login} />
      <PrivateRoute path="/" exact>
        <ParentContact />
      </PrivateRoute>
      <PrivateRoute path="/profile" exact>
        <Profile />
      </PrivateRoute>
      <PrivateRoute path="/absenceform">
        <AbsenceForm />
      </PrivateRoute>
      <Route path="/absenceformdetails/:id" component={AbsenceDetail} />
      <Route path="/profile/:school/:studentId/:token" component={ClearAbsence} />
      <PrivateRoute path="/earlyleaveform">
        <EarlyLeaveForm />
      </PrivateRoute>
      <Route path="/thankyou" component={ThankYou} />
      <Route path="" component={PageNotFound} />
    </Switch>
  </AppWrapper>
);

export default App;
